export default __webpack_public_path__ + "static/media/IMG-600x400-MairieMidoun.9294cd6a.jpg";